import React from "react";
import { useTheme } from "../context/ThemeContext";

type LeftTableProps = {
  data: { label: string; value: string | number | React.ReactNode }[];
  margin?: string;
};

// Converter HEX -> rgba(r,g,b,alpha)
function hexToRgba(hex: string | undefined, alpha: number): string {
  if (!hex) return `rgba(18, 66, 128, ${alpha})`; // fallback
  const clean = hex.replace("#", "");
  if (clean.length !== 6) return `rgba(18, 66, 128, ${alpha})`;

  const r = parseInt(clean.slice(0, 2), 16);
  const g = parseInt(clean.slice(2, 4), 16);
  const b = parseInt(clean.slice(4, 6), 16);

  if ([r, g, b].some((v) => Number.isNaN(v))) {
    return `rgba(18, 66, 128, ${alpha})`;
  }
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

const LeftTable: React.FC<LeftTableProps> = ({ data, margin = "0" }) => {
  const { theme } = useTheme();
  const primary = theme?.primary;

  const primaryOpaque = hexToRgba(primary, 0.9); // sua cor principal com alpha

  return (
    <div
      style={{
        margin,
        padding: 0,
        fontFamily: "Inter, sans-serif",
        boxSizing: "border-box",
      }}
    >
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          margin: 0,
          tableLayout: "fixed",
        }}
      >
        <thead>
          <tr>
            <th
              colSpan={2}
              style={{
                backgroundColor: primary,
                color: "#ffffff",
                fontWeight: 300,
                fontSize: "15px",
                height: "32px",
                textAlign: "center",
                padding: "0 16px",
                borderTop: "1px solid black",
                borderLeft: "1px solid black",
                borderRight: "1px solid black",
              }}
            >
              Informações da O.S
            </th>
          </tr>
        </thead>

        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td
                style={{
                  backgroundColor: primaryOpaque, // <<<<<< AQUI usando seu primary com alpha
                  color: "#ffffff",
                  fontWeight: 300,
                  fontSize: "14px",
                  padding: "6px 8px",
                  width: "240px",
                  textAlign: "center",
                  borderLeft: "1px solid black",
                  borderRight: "1px solid black",
                  borderBottom: "1px solid black",
                }}
              >
                {item.label}
              </td>

              <td
                style={{
                  backgroundColor: "#ffffff",
                  color: "#000000",
                  fontSize: "14px",
                  padding: "6px 16px",
                  textAlign: "left",
                  borderRight: "1px solid black",
                  borderBottom: "1px solid black",
                }}
              >
                {item.value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LeftTable;
